import React, { useContext, useEffect, useState } from 'react';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import { useSelector } from 'react-redux';
import { WelletContext } from '../../../context/WelletContext';
import ReservationCheckCustomerInfo from '../../../components/ReservationCheck/ReservationCheckCustomerInfo/ReservationCheckCustomerInfo';
import useForm from '../../../helpers/useForm';
import { useTranslation } from 'react-i18next';
import { isValidPhoneNumber } from 'react-phone-number-input';
import ButtonProccessing, {
  ButtonStatus,
} from '../../../components/Common/ButtonProccessing/ButtonProccessing';
import { putReservation } from '../../../services/reservations/reservationsService';
import { useHistory } from 'react-router-dom';
import { CircleSpinner } from 'react-spinners-kit';
import { format } from 'date-fns';
import EventHeader from '../../../components/Common/EventHeader/EventHeader';
import { getQueryString } from '../../../helpers/url';
import styles from './Form.module.css';
import LeadReason from '../../../components/LeadReason/LeadReason';
import LeadTime from '../../../components/LeadTime/LeadTime';
import CustomerSpecialRequest from '../../../components/ReservationCheck/CustomerSpecialRequest/CustomerSpecialRequest';

const Form = () => {
  const app = useSelector((state) => state.app);
  const currency = useSelector((state) => state.currency.default);
  const welletContext = useContext(WelletContext);
  const history = useHistory();
  const { t } = useTranslation();
  const [phoneError, setPhoneError] = useState('');
  const countryCode = useSelector((state) => state.app.currentMarket?.countryCode);
  const showId = getQueryString('showId');
  const [loading, setLoading] = useState(true);
  const [contactMethod, setContactMethod] = useState(null);
  const [amount, setAmount] = useState(0);
  const [btnStatus, setBtnStatus] = useState(ButtonStatus.Normal);
  const [reservationDate, setReservation] = useState(new Date());
  const [show, setShow] = useState(null);
  //const [customerContact, setCustomerContact] = useState(false);
  const [selectedRelationship, setSelectedRelationship] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedReason, setSelectedReason] = useState(null);

  const [informationComplete, setInformationComplete] = useState(false);
  const [customerContact, setCustomerContact] = useState(false);

  const sendTypes = [
    {
      value: 'WhatsApp',
      label: 'WhatsApp',
    },
    {
      value: 'E-mail',
      label: 'E-mail',
    },
    {
      value: 'Teléfono Móvil',
      label: 'Teléfono Móvil',
    },
  ];

  const relationships = [
    {
      value: 'Amigo',
      label: 'Amigo',
    },
    {
      value: 'Familiar',
      label: 'Familiar',
    },
    {
      value: 'Profesional',
      label: 'Profesional',
    },
  ];

  const handleInformationCheck = () => {
    setInformationComplete(!informationComplete);
  };

  const handleCustomerContactCheck = () => {
    setCustomerContact(!customerContact);
  };

  const handleSelectedTime = (e) => {
    setSelectedTime(e);
    delete errors.selectedTime;
  };

  const handleSelectedReason = (e) => {
    setSelectedReason(e);
    delete errors.selectedReason;
  };

  const handleSelectRelationship = (e) => {
    setSelectedRelationship(e);
    delete errors.selectedRelationship;
  };

  const handleSelectContact = (e) => {
    setContactMethod(e);
    delete errors.contactMethod;
  };

  const getShow = async () => {
    setLoading(true);
    try {
      const result = await welletContext.apis.tickets.get(`/shows/get/`, {
        params: {
          showId: showId,
          lang: app.language,
        },
      });

      setShow(result.data);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  function validate(values) {
    let errors = {};

    if (!values.customerName) {
      errors.customerName = t('nameError.EMPTY_NAME');
    } else if (/\d/.test(values.customerName)) {
      errors.customerName = t('nameError.NOT_NUMBERS');
    }

    if (!values.customerLastname) {
      errors.customerLastname = t('nameError.EMPTY_LASTNAME');
    } else if (/\d/.test(values.customerLastname)) {
      errors.customerLastname = t('nameError.NOT_NUMBERS');
    }

    if (!values.phone) {
      errors.phone = t('phoneError.EMPTY_PHONE_NUMBER');
      setPhoneError(errors.phone);
    } else {
      setPhoneError('');
    }

    if (values.phone && !isValidPhoneNumber(values.phone)) {
      errors.phone = t('phoneError.INVALID_PHONE_NUMBER');
      setPhoneError(errors.phone);
    }

    if (contactMethod === null) {
      errors.contactMethod = t('Metodo de envio requerido');
    }
    if (contactMethod === 'EMAIL' && !values.email) {
      errors.email = t('emailError.EMPTY_EMAIL');
    }
    if (values.email && !/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = t('emailError.INVALID_EMAIL');
    }

    if (selectedReason === null) {
      errors.selectedReason = t('Seleccione un motivo de compra');
    }

    if (selectedTime === null) {
      errors.selectedTime = t('Seleccione el tiempo de compra estimado');
    }

    if (selectedRelationship === null) {
      errors.selectedRelationship = t('Seleccione la relación con el cliente');
    }

    return errors;
  }

  const sendForm = async () => {
    setBtnStatus(ButtonStatus.InProgress);
    const customer = {
      firstName: values.customerName,
      LastName: values.customerLastname,
      email: values.email,
      phone: values.phone,
    };

    const customFields = {
      'Tiempo de compra estimado': selectedTime,
      'Motivo de la compra': selectedReason,
      'Relación con el cliente': selectedRelationship,
      'Forma de contacto preferida': contactMethod,
    };

    try {
      const result = await putReservation(
        showId,
        1,
        customer,
        values.comments,
        null,
        null,
        format(reservationDate, "yyyy-MM-dd'T'HH:mm:ss.SSS"),
        amount,
        [],
        null,
        null,
        'LEAD',
        null,
        52500,
        null,
        null,
        welletContext,
        currency.shortForm,
        customFields,
      );
      setBtnStatus(ButtonStatus.ProgressFinished);
      setTimeout(() => {
        history.push(`/lead-confirmation?reservationId=${result.reservationId}`);
      }, 1500);
    } catch (error) {
      console.error(error);
      setBtnStatus(ButtonStatus.Error);
    }
  };

  let { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  useEffect(() => {
    getShow();
  }, []);

  const Form = () => {
    return (
      <>
        <Header />
        <ContentApp>
          <EventHeader
            eventImg={show?.bannerImageUrl}
            eventName={show?.name}
            eventDescription={show?.city.name}
            size='small'
          />

          <div className='mt-4'>
            <div className='fw-semibold text-primary font-tiny mb-3'>
              {t('customerInformation')}
            </div>
            <ReservationCheckCustomerInfo
              handleChange={handleChange}
              values={values}
              errors={errors}
              phoneError={phoneError}
              setPhoneError={setPhoneError}
              countryCode={countryCode}
            />
          </div>

          <div className='mt-4 position-relative'>
            <LeadTime handleSelectButton={handleSelectedTime} selectedButton={selectedTime} />
            {errors.selectedTime && (
              <div
                className='error-label text-center'
                style={{ position: 'relative', marginTop: '10px' }}
              >
                {errors.selectedTime}
              </div>
            )}
          </div>

          <div className='mt-4 position-relative'>
            <LeadReason handleSelectButton={handleSelectedReason} selectedButton={selectedReason} />
            {errors.selectedReason && (
              <div
                className='error-label text-center'
                style={{ position: 'relative', marginTop: '10px' }}
              >
                {errors.selectedReason}
              </div>
            )}
          </div>

          <div className='text-primary font-tiny fw-semibold mt-4'>
            {t('Relación con el cliente')}
          </div>
          <div className='row mt-3 mx-0'>
            {relationships.map((p, i) => (
              <div className='col px-1' key={i}>
                <button
                  onClick={() => handleSelectRelationship(p.value)}
                  className={`font-small w-100 p-0 ${styles.linkButton} ${
                    selectedRelationship === p.value ? styles.selected : ''
                  }`}
                  type='button'
                >
                  {p.label}
                </button>
              </div>
            ))}
            {errors.selectedRelationship && (
              <div
                className='error-label text-center'
                style={{ position: 'relative', marginTop: '10px' }}
              >
                {errors.selectedRelationship}
              </div>
            )}
          </div>

          <div className='text-primary font-tiny fw-semibold mt-4'>
            {t('Forma de contacto preferida')}
          </div>
          <div className='row mt-3 mx-0'>
            {sendTypes.map((p, i) => (
              <div className='col px-1' key={i}>
                <button
                  onClick={() => handleSelectContact(p.value)}
                  className={`font-small w-100 p-0 ${styles.linkButton} ${
                    contactMethod === p.value ? styles.selected : ''
                  }`}
                  type='button'
                >
                  {p.label}
                </button>
              </div>
            ))}
            {errors.contactMethod && (
              <div
                className='error-label text-center'
                style={{ position: 'relative', marginTop: '10px' }}
              >
                {errors.contactMethod}</div>
            )}
          </div>
          <div className='mt-4'>
            <CustomerSpecialRequest
              open={true}
              values={values}
              handleChange={handleChange}
              title={t('Comentarios adicionales (opcional)')}
            />
          </div>

          <div className='text-primary font-tiny fw-semibold mt-4'>
            {t('Consentimiento y verificación')}
          </div>
          <div className='mt-4'>
            <label className='checkbox-container'>
              <input
                type='checkbox'
                style={{ width: '20px', height: '20px' }}
                checked={informationComplete}
                onChange={handleInformationCheck}
              />
              <span className='checkmark'></span>
              <div style={{ marginLeft: '2rem' }}>
                {t('La información proporcionada es correcta y completa.')}
              </div>
            </label>
          </div>

          <div className='mt-4'>
            <label className='checkbox-container'>
              <input
                type='checkbox'
                style={{ width: '20px', height: '20px' }}
                checked={customerContact}
                onChange={handleCustomerContactCheck}
              />
              <span className='checkmark'></span>
              <div style={{ marginLeft: '2rem' }}>
                {t('El cliente está de acuerdo con ser contactado por un agente.')}
              </div>
            </label>
          </div>

          <ButtonProccessing
            status={btnStatus}
            className={'mt-4'}
            text={t('Enviar deal')}
            onClick={handleSubmit}
            arrow
            size='large'
            color='#000'
            backgroundColor='var(--color-primary)'
            iconColor='#000'
          />
        </ContentApp>
      </>
    );
  };

  return (
    <>
      {loading ? (
        <div className='loaderDiv'>
          <CircleSpinner
            className='spinner-app mx-auto'
            style={{ margin: 'auto' }}
            size={40}
            color='var(--color-font-primary)'
          />
        </div>
      ) : (
        Form()
      )}
    </>
  );
};

export default Form;
